'use strict';

import angular from 'angular';
import AddController from './add.controller';

export default angular.module('updateServerApp.dictionaries.add', [])
  .controller('DictionariesAddController', AddController)
  .name;



// WEBPACK FOOTER //
// ./client/app/dictionaries/add/index.js